import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {ShortTeam} from "@/types";
import {TeamSummary} from "@/types/teams";

const page = usePage()

const isGuest = computed<boolean>(() => {
    return page.props.guest as boolean
})

const teams = computed<Array<ShortTeam>>(() => {
    return page.props.teams as Array<TeamSummary>
})

const teamsWithPermissions = computed<Array<ShortTeam>>(() => {
    return teams.value.filter(team => team.role !== 'guest')
})

const canCreateAssessment = computed<boolean>(() => {
    return teams.value.some(team => team.role !== 'guest')
})

export const useTeam = () => {
    return {
        isGuest,
        teams,
        teamsWithPermissions,
        canCreateAssessment
    }
}
